import { Mail, MessageSquare } from "lucide-react";

import { Accent, SplitFeature } from "@/features/portal/components/portal-ui";
import { m } from "@/paraglide/messages.js";
import { getLocale } from "@/paraglide/runtime.js";

const message =
  "flex flex-col rounded-[18px] bg-background p-5 shadow-[0_14px_30px_color-mix(in_oklch,var(--primary)_14%,transparent)]";
const channel = "flex items-center gap-2 text-xs font-semibold tracking-[0.1em] text-muted-foreground uppercase";

/**
 * What lands in the inbox, told beside the two messages themselves: the morning summary of the
 * day and the reminder the day before a session.
 */
export const DayReminders = () => {
  const today = new Intl.DateTimeFormat(getLocale(), { weekday: "long" }).format(new Date());
  const day = [m.portal_remind_digest_session(), m.portal_remind_digest_plan(), m.portal_remind_digest_diet()];

  return (
    <SplitFeature
      eyebrow={m.portal_remind_eyebrow()}
      title={
        <>
          {m.portal_remind_title_lead()}
          <br />
          <Accent>{m.portal_remind_title_tail()}</Accent>
        </>
      }
      body={m.portal_remind_body()}
    >
      <div aria-hidden className={message}>
        <span className={channel}>
          <Mail className="size-4 text-[var(--site-ink)]" />
          {m.portal_remind_email_when()}
        </span>
        <b className="mt-4 text-xl font-semibold tracking-[-0.02em]">{m.portal_remind_email_subject({ day: today })}</b>
        <ul className="mt-4 grid gap-2.5 text-sm">
          {day.map((line) => (
            <li key={line} className="flex items-center gap-2.5 rounded-xl bg-[var(--site-well)] px-3 py-2.5">
              <i className="size-1.5 shrink-0 rounded-full bg-primary" />
              {line}
            </li>
          ))}
        </ul>
      </div>
      <div aria-hidden className={message}>
        <span className={channel}>
          <MessageSquare className="size-4 text-[var(--site-ink)]" />
          {m.portal_remind_sms_when()}
        </span>
        <p className="mt-4 self-start rounded-[18px_18px_18px_6px] bg-primary px-4 py-3 text-[15px] leading-snug text-primary-foreground">
          {m.portal_remind_sms_text()}
        </p>
        <small className="mt-2 text-xs text-muted-foreground">{m.portal_remind_sms_from()}</small>
      </div>
    </SplitFeature>
  );
};
